import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import WeeklyBoosts from './boosts/WeeklyBoosts';
import SpecialOfferBoosts from './boosts/SpecialOfferBoosts';
import PeriodOfferBoosts from './boosts/PeriodOfferBoosts';


const BoostList = () => {
    const [selectedTab, setSelectedTab] = useState(0);

    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Tabs
                value={selectedTab}
                onChange={handleChange}
                orientation="horizontal"
                variant="scrollable"
                sx={{ borderRight: 1, borderColor: 'divider' }}
            >
                <Tab label="Weekly Boosts" />
                <Tab label="Special Offer Boosts" />
                <Tab label="Period Boosts" />
            </Tabs>

            <Box sx={{ mt: 2 }}>
                {selectedTab === 0 && <WeeklyBoosts />}
                {selectedTab === 1 && <SpecialOfferBoosts />}
                {selectedTab === 2 && <PeriodOfferBoosts />}
            </Box>
        </Box>
    );
};

export default BoostList;
